<template>
  <v-alert :dismissible="closable" v-if="show" border="left" :type="type" dense :color="color" text :icon="icon" close-icon="mdi-close">
    <span :class="color + '--text'" v-html="info"></span>
    <v-btn v-if="isAction" :small="$vuetify.breakpoint.xs" label @click="$emit('action')">{{ actionTitle }}</v-btn>
    <slot name="default"></slot>
  </v-alert>
</template>

<script>
// @group Global Component
export default {
  inheritAttrs: false,
  props: {
    title: {
      type: String,
      default: "Info",
    },
    info: {
      type: String,
      default: "",
    },
    icon: {
      type: String,
      default: "mdi-information",
    },
    color: {
      type: String,
      default: "primary",
    },
    type: {
      type: String,
      default: "info",
    },
    show: {
      type: Boolean,
      default: false,
    },
    isAction: {
      type: Boolean,
      default: false,
    },
    actionTitle: {
      type: String,
      default: "",
    },
    closable: {
      type: Boolean,
      default: false,
    },
  },
  computed: {},
};
</script>

<style></style>
